import { type OrganizationUserApiKeyStatusEnum } from '@/libs/openapi';
import { fromApiOrganizationUserApiKeyFieldAdapter } from '@/resources/organization-user-api-key/organization-user-api-key.field-adapter';
import { defineFilterListAdapter } from '@/utils/define-filter-list-adapter.util';

interface OrganizationUserApiKeyFilters {
  status: OrganizationUserApiKeyStatusEnum[];
}

export const organizationUserApiKeyFilterListAdapter = defineFilterListAdapter<OrganizationUserApiKeyFilters>({
  status: (value) => value.map((status) => ({
    filterValue: status,
    category: 'Status',
    value: fromApiOrganizationUserApiKeyFieldAdapter.forLabel.status(status),
  })),
});
